import type { TweetEngagementStatsAllOf } from './tweetEngagementStatsAllOf';
import type { TweetEngagementStatsAllOfTwo } from './tweetEngagementStatsAllOfTwo';

export type TweetEngagementStats = TweetEngagementStatsAllOf & TweetEngagementStatsAllOfTwo;
